module.exports = __webpack_public_path__ + "img/no image.1e19fc9d.png";